import { fabric } from "fabric";

export default class DeskpadHistory {
  constructor(canvas) {
    this.canvas = canvas;
    this.reset();
    this.trackHistory();
  }

  trackHistory = () => {
    const { canvas } = this;
    canvas.on({
      "canvas:loaded": e => {
        this.reset();
      }
    });
    const eventsToTrack = [
      // "object:modified",
      "object:moved",
      "object:rotated",
      "object:scaled",
      "object:removed",
      "object:added",
      "text:editing:exited",
      "text:color",
      "text:format"
    ];

    const eventsObj = {};
    eventsToTrack.forEach(eventName => {
      eventsObj[eventName] = e => {
        if (
          !e.target ||
          !e.target.canvas ||
          !e.target.canvas.loaded ||
          e.target.excludeFromExport ||
          !e.target.id
        ) {
          return;
        }
        if (!this.canvas.stateful) {
          return;
        }
        // console.group("History push");
        // console.log("Name", eventName);
        this.push(e.target, eventName);
      };
    });
    canvas.on(eventsObj);
  };

  reset = _ => {
    const snapshot = this.getSnapshot();
    const event = "initial";
    const target = null;
    this.history = [{ snapshot, event, target }];
    this.index = 0;
    this.triggerHistoryChange();
  };

  getSnapshot = (linked = false) => {
    const { canvas } = this;
    const objs = canvas.getObjects().filter(obj => !obj.excludeFromExport);
    if (linked) return objs;
    return objs.map(obj => this.getObjectSnapshot(obj));
  };

  triggerHistoryChange = _ => {
    const { canvas } = this;
    canvas.fire("history:changed", {
      history: [...this.history],
      index: this.index
    });
  };

  push = (target, event) => {
    const { index, history } = this;
    if (index < history.length - 1) {
      this.history = history.slice(0, index + 1);
    }
    const snapshot = this.getSnapshot();
    this.history.push({ snapshot, event, target });
    this.index++;
    // console.log(snapshot);
    // console.log(`Index ${this.index} Length ${this.history.length}`);
    // console.groupEnd("History push");
    this.triggerHistoryChange();
  };

  undo = _ => {
    const newIndex = this.index - 1;
    if (newIndex < 0) {
      return;
    }
    this.applySnapshot(newIndex);
    this.triggerHistoryChange();
  };

  redo = _ => {
    const { index, history } = this;
    const newIndex = index + 1;
    if (newIndex >= history.length) {
      return;
    }
    this.applySnapshot(newIndex);
    this.triggerHistoryChange();
  };

  findObjectInSnapshot = (spnpshot, id) => {
    return spnpshot.find(obj => obj.id === id);
  };

  applySnapshot(i) {
    // console.group("History apply");
    const { canvas } = this;
    const snapshot = this.history[i].snapshot;

    canvas.renderOnAddRemove = false;
    canvas.stateful = false;
    canvas.loaded = false;
    let updated = 0;
    let added = 0;
    let removed = 0;

    const currentCanvasObjects = this.getSnapshot(true);
    snapshot.forEach(obj => {
      const objOnCanvas = this.findObjectInSnapshot(
        currentCanvasObjects,
        obj.id
      );
      if (objOnCanvas) {
        objOnCanvas.set(obj);
        updated++;
      } else {
        const objToAdd = this.createObjFromSnapshot(obj);
        canvas.add(objToAdd);
        added++;
      }
    });

    const updatedCanvasObjects = this.getSnapshot(true);
    updatedCanvasObjects.forEach(obj => {
      const objFromSnapshot = this.findObjectInSnapshot(snapshot, obj.id);
      if (!objFromSnapshot) {
        canvas.remove(obj);
        removed++;
      }
    });

    canvas.renderOnAddRemove = true;
    canvas.stateful = true;
    canvas.loaded = true;

    canvas.renderAll();

    this.index = i;
    console.log(`Updated ${updated} Added ${added} Removed ${removed}`);
    console.log(`Index ${this.index} Length ${this.history.length}`);
    // console.groupEnd("History apply");
  }

  createObjFromSnapshot = obj => {
    if (obj.type === "i-text") {
      return new window.fabric.IText(obj.text, obj);
    }
    //image is already an fabirc object
    if (obj.type === "image") {
      return obj;
    }
  };

  getObjectSnapshot = obj => {
    const propsToClone = [
      "left",
      "top",
      "widht",
      "height",
      "id",
      "type",
      "fill",
      "flipX",
      "flipY",
      "fontSize",
      "fontFamily",
      "fontStyle",
      "fontWeight",
      "textAlign",
      "text",
      "zoomX",
      "zoomY",
      "angle",
      "scaleX",
      "scaleY",
      "globalCompositeOperation",
      "visible",
      "thumb",
      "hash",
      "size",
      "src",
      "isVector",
      "zIndex"
    ];

    let objSnapshot = {};
    //TODO: implement own clone method for image
    //Makeing image clone, to prevent using fromURL when it will be need to restore
    if (obj.type === "image") {
      objSnapshot = fabric.util.object.clone(obj);
    }
    propsToClone.forEach(prop => {
      if (obj[prop] === undefined) return;
      objSnapshot[prop] = obj[prop];
    });
    return objSnapshot;
  };
}
